import { useCallback, useState } from 'react';
import { useTranslations } from 'next-intl';
import { toasterApi } from '@terra/ui-design-system';
import { useUserTenants } from './api/useUserTenants';
import { setCurrentTenantId as setCachedTenantId } from '../store/tenantStorage';

export function useSwitchTenant() {
  const t = useTranslations('layout');
  const { currentTenantId } = useUserTenants();
  const [isSwitching, setIsSwitching] = useState(false);

  const switchTenant = useCallback(
    async (tenantId: string): Promise<void> => {
      if (tenantId === currentTenantId || isSwitching) {
        return;
      }

      if (typeof window === 'undefined' || !window.electronAPI?.auth) {
        toasterApi.error({
          title: t('switchTenantFailed'),
          description: t('switchTenantNotReady'),
        });

        return;
      }

      setIsSwitching(true);

      try {
        const result = await window.electronAPI.auth.selectTenant(tenantId);

        if (!result.success) {
          throw new Error(result.error ?? t('switchTenantTryAgain'));
        }

        setCachedTenantId(tenantId);
        window.location.reload();
      } catch (error) {
        console.error('Failed to switch tenant:', error);
        toasterApi.error({
          title: t('switchTenantFailed'),
          description:
            error instanceof Error ? error.message : t('switchTenantTryAgain'),
        });
        setIsSwitching(false);
      }
    },
    [currentTenantId, isSwitching, t],
  );

  return { switchTenant, isSwitching };
}
